import { render } from "./PartnersContactsdetails.vue?vue&type=template&id=028450ba&scoped=true"
import script from "./PartnersContactsdetails.vue?vue&type=script&lang=js"
export * from "./PartnersContactsdetails.vue?vue&type=script&lang=js"

import "./PartnersContactsdetails.vue?vue&type=style&index=0&id=028450ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028450ba"]])

export default __exports__